import React from "react";
import CampaignIcon from "@mui/icons-material/Campaign";

const AnnouncementsWidget = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col gap-4">
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="font-bold text-gray-800 flex items-center gap-2">
          <CampaignIcon className="text-orange-500" />
          Announcements
        </h3>
      </div>
      <div className="flex-1 flex items-center justify-center min-h-[150px]">
        <p className="text-gray-400 italic text-sm">No new announcements at this time.</p>
      </div>
    </div>
  );
};

export default AnnouncementsWidget;
